import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";
import { FadeUp, SectionHeading } from "@/components/Reveal";
import InquiryForm from "@/components/InquiryForm";
import { ADDRESS, PHONE_DISPLAY, ALT_PHONE_DISPLAY, WHATSAPP_LINK } from "@/data/site";

const ContactSection = () => (
  <section id="contact" className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-12 lg:py-32" data-testid="contact-section">
    <SectionHeading
      eyebrow="Start something"
      title="Tell us what you're building."
      sub="Pick a service, drop a line, or just WhatsApp us. We reply within one business day — usually faster."
    />
    <div className="mt-14 grid gap-8 lg:grid-cols-[400px_1fr]">
      <FadeUp>
        <div className="flex h-full flex-col gap-4">
          <div className="rounded-2xl border border-white/10 bg-[#131316] p-7">
            <MapPin className="h-6 w-6 text-[#D9A92E]" />
            <h3 className="mt-4 text-base font-semibold text-white">Visit the studio</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#A1A1AA]" data-testid="contact-address">
              {ADDRESS}
            </p>
          </div>
          <div className="rounded-2xl border border-white/10 bg-[#131316] p-7">
            <Phone className="h-6 w-6 text-[#D9A92E]" />
            <h3 className="mt-4 text-base font-semibold text-white">Call or WhatsApp</h3>
            <p className="mt-2 text-sm text-[#A1A1AA]">{PHONE_DISPLAY}</p>
            <p className="mt-1 text-sm text-[#A1A1AA]">{ALT_PHONE_DISPLAY}</p>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-button"
              className="mt-5 flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-white transition-all duration-300 hover:brightness-110"
            >
              <MessageCircle className="h-4 w-4" />
              Chat on WhatsApp
            </a>
          </div>
          <div className="rounded-2xl border border-white/10 bg-[#131316] p-7">
            <Clock className="h-6 w-6 text-[#D9A92E]" />
            <h3 className="mt-4 text-base font-semibold text-white">Hours</h3>
            <p className="mt-2 text-sm text-[#A1A1AA]">Mon – Sat, 11:00 AM – 5:00 PM ET</p>
          </div>
        </div>
      </FadeUp>
      <FadeUp delay={0.12}>
        <div className="rounded-2xl border border-white/10 bg-[#131316] p-8 lg:p-10">
          <h3 className="font-display text-xl font-bold text-white">Send an inquiry</h3>
          <p className="mt-2 text-sm text-[#A1A1AA]">
            Choose the service you're curious about and tell us where you want to go.
          </p>
          <div className="mt-7">
            <InquiryForm showServiceSelect testidPrefix="contact-form" />
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default ContactSection;
